import React, { useEffect, useState } from "react";
import {
  fetchServiceAndTaxSettings,
  saveServiceAndTaxSettingsAndSessions,
} from "../../../services/Settings/ServicesandTaxSettingsAndSessios/ServicesAndTaxApi";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  Stack,
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";

const INCREMENT_TYPES = [
  { value: "general_increment", label: "ترقيم عام" },
  { value: "daily_increment", label: "ترقيم يومي" },
  { value: "monthly_increment", label: "ترقيم شهري" },
];

const BillOrderSettings = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [invoiceIncrement, setInvoiceIncrement] = useState("");

  // ✅ تحميل البيانات
  useEffect(() => {
    const loadSettings = async () => {
      setLoading(true);
      try {
        const res = await fetchServiceAndTaxSettings();
        const s = res?.data?.settings?.[0] || res || {};
        setSettings(s);
        if (s.invoice_incremant) {
          setInvoiceIncrement(s.invoice_incremant);
        }
      } catch (error) {
        console.error("❌ فشل تحميل الإعدادات:", error);
        setSettings({});
      } finally {
        setLoading(false);
      }
    };
    loadSettings();
  }, []);

  // ✅ حفظ البيانات
  const handleSave = async () => {
    try {
      await saveServiceAndTaxSettingsAndSessions({
        ...settings,
        invoice_incremant: invoiceIncrement,
      });
      setSuccessMsg("✅ تم تحديث إعدادات الفواتير بنجاح!");
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setSuccessMsg("❌ فشل في تحديث إعدادات الفواتير.");
      setTimeout(() => setSuccessMsg(""), 3000);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}>
        <CircularProgress size={40} />
      </Box>
    );
  }

  return (
    <Paper
      elevation={8}
      sx={{
        p: { xs: 2, sm: 4 },
        mt: 3,
        borderRadius: 5,
        background:
          theme.palette.mode === "dark"
            ? "linear-gradient(135deg, #23272f 0%, #1a1a1a 100%)"
            : "linear-gradient(135deg, #e3f2fd 0%, #f5f5f5 100%)",
        boxShadow: "0 8px 32px rgba(33,150,243,0.12)",
        maxWidth: 440,
        mx: "auto",
      }}
    >
      {/* العنوان */}
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <ReceiptIcon sx={{ fontSize: 48, color: theme.palette.primary.main, mb: 1 }} />
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: theme.palette.mode === "dark" ? "#90caf9" : "#1976d2",
            letterSpacing: 1,
            mb: 1,
          }}
        >
          إعدادات الفواتير
        </Typography>
        <Typography sx={{ color: theme.palette.text.secondary, fontSize: "1rem" }}>
          اختر نوع الترقيم الخاص بالفواتير (عام / يومي / شهري).
        </Typography>
      </Box>

      {/* اختيار نوع الترقيم */}
      <Stack spacing={3} sx={{ mb: 2 }}>
        <FormControl fullWidth>
          <InputLabel id="invoice-increment-label">نوع الترقيم</InputLabel>
          <Select
            labelId="invoice-increment-label"
            value={invoiceIncrement}
            onChange={(e) => setInvoiceIncrement(e.target.value)}
            sx={{
              borderRadius: 3,
              background: theme.palette.mode === "dark" ? "#23272f" : "#fff",
            }}
          >
            {INCREMENT_TYPES.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      {/* زر الحفظ */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{
          mt: 2,
          fontWeight: "bold",
          borderRadius: 3,
          boxShadow: "0 2px 8px rgba(33,150,243,0.12)",
          py: 1.2,
          fontSize: "1rem",
          letterSpacing: 1,
          width: "100%",
        }}
      >
        حفظ التعديلات
      </Button>

      {/* رسالة النجاح أو الفشل */}
      {successMsg && (
        <Typography
          sx={{
            mt: 2,
            textAlign: "center",
            fontWeight: "bold",
            color: successMsg.startsWith("✅") ? "#388e3c" : "#d32f2f",
            background: theme.palette.mode === "dark" ? "#23272f" : "#f5f5f5",
            borderRadius: 2,
            py: 1,
          }}
        >
          {successMsg}
        </Typography>
      )}
    </Paper>
  );
};

export default BillOrderSettings;
